<template>
   <div class="wrapper signup-page-wrp">
		<div class="signup-page ">
			<div class="signup-page-left">
				<div class="align">
					<h1> Company Profile</h1>

				</div>
			</div>
			<div class="signup-page-right">
				<div class="align">
					<form class="signin-form ">
						<div class="step-holder">
							<div class="tab-heading">
								<h1>Company Information</h1>
							</div>



							<!-- Step 1 -->
							<div class="steps ">
								<div class="comp-info-step">
									<div class="row ">
										<div class="col-sm-8 pd-lr ">
											<div class="form-group">
												<label for="">Company Name</label>
												<div class="input-wrapper">
													<input type="email" class="form-control form-control-lg "
														value="" placeholder="" v-model="form.name">
												</div>
											</div>
										</div>
										<div class="col-sm-4 pd-lr">
											<div class="form-group">
												<label for="">CVR</label>
												<input type="text" class="form-control form-control-lg "
													placeholder="" v-model="form.cvr">
											</div>
										</div>
										<div class="col-sm-8 pd-lr">
											<div class="form-group">
												<label for="">Address</label>
												<div class="input-wrapper">
													<input type="text" class="form-control form-control-lg "
														value="" placeholder="" v-model="form.address">
												</div>
											</div>
										</div>
										<div class="col-sm-4 pd-lr">
											<div class="form-group">
												<label for="">Post Code</label>
												<div class="input-wrapper">
													<input type="email" class="form-control form-control-lg "
														placeholder="" v-model="form.postcode">
												</div>
											</div>
										</div>

										<div class="col-sm-12 pd-lr ">
											<div class="form-group">
												<label for="">Job Roles</label>

												<!-- <input type="email" class="form-control form-control-lg "
													id="exampleInputEmail1" aria-describedby="emailHelp" placeholder=""> -->
												 <multiselect v-model="form.jobRoles" tag-placeholder="Add this as new tag" placeholder="Search or add a tag"
                         label="name"
                         track-by="name"
                         :options="unique"
                         :multiple="true"
                         :taggable="true"
                         :max-height="200"
                         @tag="addTag"  ></multiselect>
												 <!-- <pre ><code>{{ value  }}</code></pre> -->
											</div>
										</div>
									</div>

								</div>
								<div class="update-link">
									<a href="#" class=""> Add/Update Income Tax Settings</a>
								</div>
							</div>

							<div class="tab-foot text-center">
								<router-link :to="{ path: '/company-profile' }">
									<a class="btn btn-lg btn-outline-primary"> Cancel</a>
								</router-link>
								<a class="btn btn-lg btn-primary" @click.prevent="Update">Save</a>
							</div>

						</div>
					</form>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
import login from '../Login/login.vue'
import Multiselect from 'vue-multiselect'
    export default {
        name: 'edit-company',
        components: {
			Multiselect
		},

        data() {
            return {
               form:{
                   company_id: this.$store.getters.getSelectedCompany.id,
                    name:null,
					cvr:null,
                    address:null,
                    postcode:null,
					industry_id:1,
					latitude: "31.5204",
                    longitude: "74.3587",
                    jobRoles: []
                },
				/*options: [
					{ name: 'Cleaner'},
					{ name: 'Cook' },
					{ name: 'Chef' },
                    { name: 'Waiter' },
                    { name: 'Account' },
				],*/
                options:[],
				value:[],
				getlist: [],
                id:null,
                companyid:null,
                allJobroles:[],
                unique:[],
                jobRoleUniq:[]

            }
        },
        serverPrefetch() {
            // return this.editcompany();
        },
        mounted() {
                // console.log(this.$route.params.id);
            this.editcompany();
            this.getJobRolesList();
        },
        methods: {
             addTag (newTag) {

                  this.getlist.push({'name':newTag});
                  this.jobRoleUniq.push({'name':newTag});

            },
            getJobRolesList() {
                let params = {list_type: ['job_roles']};
                this.$axios({
                    method: 'get',
                    params: params,
                    url: this.$Getlistdata,
                }).then(response => {
                        if (response.status == 200) {
                            response.data.result.job_roles.forEach(element => {
                                this.options.push({'name':element.name}); // for show above
                            });
                        }
                    }
                ).catch(error => {
                    console.log(error);
                    this.is_data_ready = true
                });
            },
            editcompany() {
                this.is_data_ready = false;
                this.id = this.$route.params.id;
                this.$axios
                    .get(this.$EditCompany.replace(':id', this.id), {
                        headers: this.getAuthHeader(),
                    })
                    .then(response => {
                    //   console.log('hello',response);return;
                        this.value = response.data.result.company;
                        this.form.jobRoles =response.data.result.jobs;
                        this.companyid = response.data.result.company.id;
                        this.form.name = this.value.name;
                        this.form.cvr = this.value.cvr;
                        this.form.address = this.value.address;
                        this.form.postcode = this.value.postcode;
                        this.form.jobRoles.forEach(element => {
                            this.getlist.push({'name': element.name}); // fo+r show above
                            this.jobRoleUniq.push(element.name);
                        });
                        this.allJobroles = this.options.concat(this.getlist);
                        this.allJobroles.map(x => this.unique.filter(a => a.name == x.name ).length > 0 ? null : this.unique.push(x));
                    })
                    .catch(error => {
                        console.log(error);
                        this.is_data_ready = true
                    })
            },
            //------------ update profile
            Update(){
                this.form.company_id=this.$route.params.id;
                this.$axios
                    .patch(this.$UpdateCompany.replace(':id',this.form.company_id),this.form,{
                        headers: this.getAuthHeader()
                    })
                    .then(response => {
                        if(response.status==200){
                            this.$store.commit('setUser',response.data.result.user);
                            $root.$toast.success(response.data.message);
                            // this.$router.go(0);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.is_data_ready = true
                    })

            },
            Update_old(){


                this.form.company_id=this.$route.params.id;
				this.$axios.post(this.$UpdateCompanyWithJobRoles ,this.form,{
                        headers: this.getAuthHeader()
                    })
                    .then(response => {
                        //this.$router.push('/company-profile');
                    })
                    .catch(error => {
                        console.log(error);
                        this.is_data_ready = true
                    })

            }
         }
    }
</script>
